import { faGrid, faList } from '@fortawesome/pro-solid-svg-icons';
import { SearchInput } from '@design-system/components/searchinput';
import { Typography } from '@design-system/components/typography/typography';
import { DropDownFilter } from '@design-system/components/dropDown/dropDownFilter';
import { IconButton } from '@design-system/components/button/iconButton';
import { clsx } from 'clsx';
import { LibraryVM } from '../view-models/library.viewModel';
import { Chip } from '@design-system/components/chip/chip';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { Row } from '@design-system/components/grid/grid';

export const LibraryFilters = (p: LibraryVM) => (
  <div
    className="flex flex-col md:flex-row gap-4 items-center w-full"
    id={p.filtersId}
  >
    <div style={{ maxWidth: '300px' }}>
      <SearchInput
        placeholder="Search by name"
        value={p.searchText}
        onChange={(e) => p.dispatch('search', e.target.value)}
        onClear={() => p.dispatch('search', '')}
      />
    </div>
    {p.filters.map(
      ({ label, options, selectedValue, deleteSelection, className }) => (
        <DropDownFilter
          key={label}
          label={label}
          options={options}
          value={selectedValue === 'extras-video' ? '' : selectedValue} // todo: fix when more advanced filters are added for library
          deleteSelection={deleteSelection}
          className={className}
        />
      ),
    )}
    <Chip
      onClick={() => {
        p.dispatch('filterExtrasVideos');
      }}
      label={
        <Row alignCenter>
          Extras video
          <Toggle
            value={p.contentFilters === 'extras-video'}
            onChange={() => {
              p.dispatch('filterExtrasVideos');
            }}
            variant="primary"
          />
        </Row>
      }
      className={clsx('bg-white hover:text-black text-black')}
    />
    <IconButton
      icon={p.showGalleryView ? faList : faGrid}
      className={clsx('p2 text-black bg-white')}
      onClick={() => p.dispatch('toogleGalleryView')}
    />
    {p.showGalleryView && (
      <div className="flex gap-2 min-w-[250px] items-center md:ml-auto">
        <Typography>Sort by</Typography>
        <DropDownFilter {...p.sortGallery} />
      </div>
    )}
  </div>
);
